/* ============
 * Getters for the global module
 * ============
 *
 * The getters that are available on the
 * global module.
 */
export const channels = (state) => {
  return state.channels
}
export const total = (state) => {
  return state.total
}
export const offset = (state) => {
  return state.offset
}
export const max = (state) => {
  return state.max
}
export const getChnlById = (state) => (id) => {
  return state.channels.find(item => item.id === id)
}
export const sort = (state) => {
  return state.sort
}
export const order = (state) => {
  return state.order
}
export default {
  channels,
  total,
  offset,
  max,
  getChnlById,
  sort,
  order
}
